<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Subscriptions">
      <div class="row">
        <div class="col-md-6 form-group">
          Select Category
          <b-form-select v-model="category" @change="getCategories()" required>
            <option
              v-for="(category, index) in categories"
              :key="index"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </b-form-select>
          <div v-if="categoryEmpty" style="color: red">
            category is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Subscription Name
          <input
            class="form-control"
            type="text"
            v-model="name"
            @focus="nameEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">
            Subscriptionname is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Validity(days)
          <input
            class="form-control"
            type="number"
            v-model="validity"
            @focus="validityEmpty = false"
          />
          <div v-if="nameEmpty" style="color: red">Validity is required</div>
        </div>
        <div class="col-md-6 form-group">
          Price
          <input
            class="form-control"
            type="number"
            v-model="price"
            @focus="priceEmpty = false"
          />
          <div v-if="priceEmpty" style="color: red">Price is required</div>
        </div>
        <div class="col-md-6 form-group">
          Discount (%)
          <input
            class="form-control"
            type="number"
            v-model="discount"
            @focus="discountEmpty = false"
          />
          <div v-if="discountEmpty" style="color: red">
            Discount is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Image
          <b-form-file
            id="file-small"
            v-model="image"
            @focus="imageEmpty = ''"
            @change="imageUpload"
          ></b-form-file>
          <div class="form-group" style="color: red" v-if="imageEmpty">
            {{ imageEmpty }}
          </div>
        </div>
        <div class="col-md-6 form-group">
          Description
          <input
            class="form-control"
            type="text"
            v-model="description"
            @focus="descriptionEmpty = false"
          />
          <div v-if="descriptionEmpty" style="color: red">
            Description is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Subscription Type
          <b-form-select v-model="subscriptiontype">
            <option value="0">College</option>
            <option value="1">User</option>
          </b-form-select>
        </div>
        <div
          v-for="(spec, index) in specs"
          :key="index"
          class="form-group row m-0"
          style="width: 100%"
        >
          <div class="col-md-11 form-group">
            Subscription Specification
            <input v-model="specs[index].specification" class="form-control" />
          </div>
          <div class="col-md-1 form-group">
            <b-button variant="danger" class="mt-4" @click="removespecs(index)"
              ><i class="fas fa-trash"></i
            ></b-button>
          </div>
        </div>
        <div class="col-md-12">
          <b-button
            variant="success"
            @click="pushSpecs()"
            class="mt-2 float-right"
            >Add Specification</b-button
          >
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          @click="addSubscription()"
          >Save</b-button
        >
      </div>
      <!-- Loader -->
        <b-overlay :show="loader" no-wrap blur="2px" opacity="0.60" class="position-fixed">
          <template #overlay>
            <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
          </template>
        </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      loader:false,
      specs: [],
      categoryEmpty: false,
      nameEmpty: false,
      validityEmpty: false,
      priceEmpty: false,
      discountEmpty: false,
      descriptionEmpty: false,
      subscriptiontypeEmpty: false,
      categories: [],
      category: "",
      name: "",
      validity: "",
      price: "",
      discount: "",
      description: "",
      subscriptiontype: "",
      image: [],
      imageEmpty: "",
    };
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    removespecs(index) {
      this.specs.splice(index, 1);
    },
    pushSpecs() {
      this.specs.push({
        specification: "",
      });
    },
    imageUpload(event) {
      this.image = event.target.files[0];
    },
    async getCategories() {
      await axios
        .get(`${this.$store.getters.baseUrl}/categories`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.categories = response.data.categories;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async addSubscription() {
      if (this.category == "") {
        this.categoryEmpty = true;
        return;
      }

      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }

      if (this.validity == "") {
        this.validityEmpty = true;
        return;
      }
      if (this.discount == "") {
        this.discountEmpty = true;
        return;
      }
      if (this.price == "") {
        this.priceEmpty = true;
        return;
      }
      if (this.description == "") {
        this.descriptionEmpty = true;
        return;
      }
      if (this.subscriptiontype == "") {
        this.subscriptiontypeEmpty = true;
        return;
      }
      if (this.image == "") {
        this.imageEmpty = "Subscription image is required";
        return;
      }
       this.loader = true;
      const formdata = new FormData();
      formdata.append("category_id", this.category);
      formdata.append("name", this.name);
      formdata.append("validity", this.validity);
      formdata.append("price", this.price);
      formdata.append("discount", this.discount);
      formdata.append("description", this.description);
      formdata.append("image", this.image);
      if (this.specs.length > 0) {
        for (var i = 0; i < this.specs.length; i++) {
          formdata.append(
            "sub_specifications[" + i + "]",
            this.specs[i].specification
          );
        }
      }
      formdata.append("subscription_type", this.subscriptiontype);
      await axios
        .post(`${this.$store.getters.baseUrl}/subscription/store`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.loader = false;
            this.$swal("Success", "Subscription added successfully", "success");
            this.$router.push({name: 'Subscriptions'});     
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

